<template>
  <layout-card-wrap
    v-loading="loading"
    hasHeaderSlot
    style="margin-top:15px">
    <template slot="title">会员成长设置</template>
    <template
      v-if="options.length > 0"
      slot="form">
      <el-button
        type="primary"
        @click="addRule">新增成长设置</el-button>
    </template>
    <el-table
      border
      :data="list">
      <el-table-column label="类型">
        <template slot-scope="{row}">
          <span>{{ row.memberScoreTypeName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="积分转换成长值比例">
        <template slot-scope="{row, $index}">
          <span>1：{{ row.ratio }}</span>
          <el-popover
            :ref="`popover_${$index}`"
            style="margin-left:10px"
            trigger="click"
            placement="right"
            @show="() => {popoverShow(row, $index)}">
            <div style="margin:10px">
              1 : <el-input-number
                v-model="row.ratioBak"
                controls-position="right"
                :min="0"></el-input-number>
              <el-button
                style="margin-left:10px"
                type="primary"
                @click="() => {updateRuleSubmit(row,`popover_${$index}`)}">确定</el-button>
            </div>
            <i
              slot="reference"
              style="cursor: pointer;"
              class="el-icon-edit"></i>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        label="是否启用"
        width="200px">
        <template slot-scope="{row}">
          <el-switch
            :value="row.isopen"
            :active-value="1"
            :inactive-value="0"
            active-text="开"
            inactive-text="关"
            @change="updateState(row)">
          </el-switch>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="新增成长设置"
      :visible.sync="dialogVisible"
      width="400px"
      @closed="handleClosed">
      <el-form
        ref="form"
        label-width="120px"
        :model="form"
        :rules="rules">
        <el-form-item
          label="类型："
          prop="memberScoreTypeCode">
          <el-select
            v-model="form.memberScoreTypeCode"
            placeholder="请选择类型">
            <el-option
              v-for="item in options"
              :key="item.memberScoreTypeCode"
              :label="item.name"
              :value="item.memberScoreTypeCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="积分:成长值：">
          1 : <el-input-number
            v-model="form.ratio"
            controls-position="right"
            :min="0"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          @click="addRuleSubmit">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </layout-card-wrap>
</template>
<script>
export default {
  name: 'LevelScoreTable',
  props: {
    vendorId: [String, Number]
  },
  data() {
    return {
      loading: true,
      options: [],
      list: [],
      form: {
        ratio: 1,
        memberScoreTypeCode: null
      },
      dialogVisible: false,
      rules: {
        memberScoreTypeCode: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ]

      }
    }
  },
  mounted() {
    // this.fetch()
  },
  methods: {
    popoverShow(row, $index) {
      row.ratioBak = row.ratio
      this.list.splice($index, 1, row)
    },
    handleClosed() {
      this.$refs['form'].resetFields()
    },
    addRuleSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$store.dispatch('member/addmemberscorerule', {
            payload: {
              vendorId: this.vendorId,
              ratio: this.form.ratio,
              memberScoreTypeCode: this.form.memberScoreTypeCode,
              isopen: 0
            },
            success: () => {
              this.dialogVisible = false
              this.fetch()
            },
            fail: () => { }
          })
        }
      })
    },
    addRule() {
      this.form.ratio = 1
      this.form.memberScoreTypeCode = null
      this.dialogVisible = true
    },
    updateRuleSubmit(row, _ref) {
      this.$store.dispatch('member/updatememberscorerule', {
        payload: {
          ratio: row.ratioBak,
          vendorId: row.vendorId,
          memberScoreId: row.memberScoreId,
          isopen: row.isopen
        },
        success: () => {
          // eslint-disable-next-line no-underscore-dangle
          this.$refs[_ref].doClose()
          this.fetch()
        },
        fail: () => { }
      })
    },
    updateState(row) {
      console.log(row)
      if (row.isopen === 1) {
        this.$store.dispatch('member/disenablememberscorerule', {
          payload: row,
          success: () => {
            this.fetch()
          },
          fail: () => { }
        })
      } else if (row.isopen === 0) {
        this.$store.dispatch('member/enablememberscorerule', {
          payload: row,
          success: () => {
            this.fetch()
          },
          fail: () => { }
        })
      }
    },
    fetchRuleTypes() {
      this.$store.dispatch('member/getnotsetedmemberscoretypes', {
        payload: {
          vendorId: this.vendorId
        },
        success: res => {
          this.options = res.data.records
        },
        fail: () => { }
      })
    },
    fetchRuleList() {
      this.loading = true
      this.$store.dispatch('member/getmemberscorerules', {
        payload: {
          vendorId: this.vendorId
        },
        success: res => {
          this.loading = false
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch() {
      this.fetchRuleList()
      this.fetchRuleTypes()
    }
  }
}
</script>
